import { render, staticRenderFns } from "./subject-grading.vue?vue&type=template&id=4860594c&scoped=true&"
import script from "./subject-grading.vue?vue&type=script&lang=js&"
export * from "./subject-grading.vue?vue&type=script&lang=js&"
import style0 from "./subject-grading.vue?vue&type=style&index=0&id=4860594c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860594c",
  null
  
)

export default component.exports